export const PAYMENT_TERMINAL_CONFIGURE = 'PAYMENT_TERMINAL_CONFIGURE'
export const PAYMENT_TERMINAL_CONNECT = 'PAYMENT_TERMINAL_CONNECT'
export const PAYMENT_TERMINAL_DISCONNECT = 'PAYMENT_TERMINAL_DISCONNECT'
export const PAYMENT_TERMINAL_SEND_REQUEST = 'PAYMENT_TERMINAL_SEND_REQUEST'

export const PAYMENT_TERMINAL_CONNECTED = 'PAYMENT_TERMINAL_CONNECTED'
export const PAYMENT_TERMINAL_DISCONNECTED = 'PAYMENT_TERMINAL_DISCONNECTED'
export const PAYMENT_TERMINAL_DISPLAY_MESSAGE_RECEIVED = 'PAYMENT_TERMINAL_DISPLAY_MESSAGE_RECEIVED'
export const PAYMENT_TERMINAL_ERROR = 'PAYMENT_TERMINAL_ERROR'
export const PAYMENT_TERMINAL_IDLE = 'PAYMENT_TERMINAL_IDLE'
export const PAYMENT_TERMINAL_TRANSACTION_COMPLETED = 'PAYMENT_TERMINAL_TRANSACTION_COMPLETED'
export const PAYMENT_TERMINAL_TRANSACTION_PROCESSING = 'PAYMENT_TERMINAL_TRANSACTION_PROCESSING'
export const PAYMENT_TERMINAL_STATUS_CHANGED = 'PAYMENT_TERMINAL_STATUS_CHANGED'
export const PAYMENT_TERMINAL_INFO_RECEIVED = 'PAYMENT_TERMINAL_INFO_RECEIVED'

export const PAYMENT_TERMINAL_RECEIVE_RAW_RESPONSE = 'PAYMENT_TERMINAL_RECEIVE_RAW_RESPONSE'
export const PAYMENT_TERMINAL_RECEIVE_RAW_REQUEST = 'PAYMENT_TERMINAL_RECEIVE_RAW_REQUEST'
